import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/handlers";
import { successHandler } from "../../../helpers/handlers";
import api from "../../../config/axios";
import { logout } from "../auth";

const initialState = {
  codes: [],
  pageLoading: false,
  actionLoading: false,
  error: null,
  nextPageToken: null,
};

const slice = createSlice({
  name: "referralCodes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, () => initialState)

      .addCase(fetchReferralCodes.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchReferralCodes.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.codes = action.payload.codes;
        state.nextPageToken = action.payload.nextPageToken;
      })
      .addCase(fetchReferralCodes.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      })

      .addCase(createReferralCode.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(createReferralCode.fulfilled, (state) => {
        state.actionLoading = false;
      })
      .addCase(createReferralCode.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      .addCase(updateReferralCode.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(updateReferralCode.fulfilled, (state, action) => {
        state.actionLoading = false;
        const updated = action.payload;
        const idx = state.codes.findIndex((c) => c.code === updated.code);
        if (idx !== -1) state.codes[idx] = { ...state.codes[idx], ...updated };
      })
      .addCase(updateReferralCode.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      .addCase(deleteReferralCode.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(deleteReferralCode.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.codes = state.codes.filter((c) => c.code !== action.payload);
      })
      .addCase(deleteReferralCode.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const fetchReferralCodes = createAsyncThunk(
  "referralCodes/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/referrals/codes", { params });
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createReferralCode = createAsyncThunk(
  "referralCodes/create",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post("/admin/referrals/codes", data);
      successHandler("Referral code created successfully");
      dispatch(fetchReferralCodes());
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateReferralCode = createAsyncThunk(
  "referralCodes/update",
  async ({ code, ...data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/admin/referrals/codes/${code}`, data);
      successHandler("Code updated");
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteReferralCode = createAsyncThunk(
  "referralCodes/delete",
  async (code, { rejectWithValue }) => {
    try {
      await api.delete(`/admin/referrals/codes/${code}`);
      successHandler("Referral code deleted");
      return code;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export default slice.reducer;
